export function format(betrag: number, printZeros = false, minimumFractionDigits = 0, addCurrency = false): string {
  let result = "";
  if (Math.abs(betrag) == 0) {
    if (printZeros) { result = "0"; }
    else { return ""; }
  }
  const isVollerEuroBetrag = Math.abs(betrag - Math.floor(betrag)) < .001;
  if (isVollerEuroBetrag && minimumFractionDigits == 0) { result = ""+Math.floor(betrag); }
  else {
    result = betrag.toLocaleString("de-DE", {
      minimumFractionDigits,
      maximumFractionDigits: 2,
    });
  }
  if (addCurrency) { result += " €"; }
  return result;
}
